import React from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ManufacturingSimulator } from "@/components/manufacturing/ManufacturingSimulator";
import { ProductionOrderList } from "@/components/manufacturing/ProductionOrderList";

const views = {
  ORDERS: "orders",
  NEW_ORDER: "new-order",
};

export function ProductionOrdersWorkspace() {
  const beforeCloseRef = React.useRef(null);
  const [view, setView] = React.useState(views.ORDERS);
  const [ordersReloadKey, setOrdersReloadKey] = React.useState(0);

  const handleOrderCreated = () => {
    setOrdersReloadKey((value) => value + 1);
    setView(views.ORDERS);
  };

  if (view === views.NEW_ORDER) {
    return (
      <div className="space-y-3">
        <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg border bg-white px-4 py-3 shadow-sm">
          <div>
            <h2 className="text-xl font-semibold">Nueva orden de fabricación</h2>
          </div>
          <Button type="button" variant="outline" onClick={() => beforeCloseRef.current?.()}>
            <ArrowLeft className="mr-2 h-4 w-4" />Volver a órdenes
          </Button>
        </div>
        <ManufacturingSimulator beforeCloseRef={beforeCloseRef} productionOrderMode onProductionOrderCreated={handleOrderCreated} />
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {new URLSearchParams(window.location.hash.split('?')[1]).get('from') === 'dashboard' && <a className="inline-block text-sm font-medium text-indigo-600 underline" href="#/cuadro-control/fabricaciones">Volver al cuadro de fabricación</a>}
      <ProductionOrderList reloadKey={ordersReloadKey} onCreate={() => setView(views.NEW_ORDER)} />
    </div>
  );
}
